var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.003,
    height: 26.005,
    viewBox: "0 0 26.003 26.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #4f8434;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #4f8434;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9968",
    "data-name": "Group 9968",
    transform: "translate(14516.5 3454.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1821",
    "data-name": "Ellipse 1821",
    className: "cls-1",
    cx: 12.501,
    cy: 12.502,
    rx: 12.501,
    ry: 12.502,
    transform: "translate(-14516 -3454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-2",
    d: "M40.649,26.442l-.858-.858a.592.592,0,0,0-.858,0L30.66,33.8,26.8,29.874a.592.592,0,0,0-.858,0l-.858.858a.592.592,0,0,0,0,.858l5.638,5.638h0l9.989-9.989A.58.58,0,0,0,40.649,26.442Z",
    transform: "translate(-14536.294 -3472.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.88f9c86e8166d45ff855fa70f60b453b.svg";
export { ForwardRef as ReactComponent };